import React from 'react';
import { HashRouter as Router,Route } from 'react-router-dom';
import './App.css';
import RouteA from "../src/model/Router";
import "./common/globalState";
class App extends React.Component{
  render(){
    function RouteWithSubRoutes(route) {
      return (
        <Route
        exact={route.exact}
          path={route.path}
          render={props => (
            // pass the sub-routes down to keep nesting
            <route.component {...props} routes={route.child} />
          )}
        />
      );
    }
    return (
      <Router>
      <div className="App">
       
        {
          RouteA.map((route,key)=>{
           
              return (<RouteWithSubRoutes  key={key} {...route}   />);
 })
        }
      
       </div>
   </Router>
    );

  }

}

export default App;
